var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('fingerprint-spinner',{attrs:{"animation-duration":1500,"size":64,"color":"#BB86FC"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }